/**
 * Uma emissão de boleto por vez na janela de emissão (BoletoEmissionModal).
 *
 * Em 23/10/2026 a fatura 14672 mandou 4 pedidos de emissão ao Asaas em 2 segundos: o
 * botão só travava depois de uma consulta ao banco, e cada clique nesse intervalo
 * abria outra emissão. O `loading` do React não resolve sozinho — ele só desabilita o
 * botão depois que a tela é redesenhada. Esta trava é lida e marcada no mesmo
 * instante do clique, antes de qualquer `await`.
 *
 * Cada emissão recebe um bilhete. Quando a janela troca de fatura, a trava é zerada e
 * o bilhete antigo deixa de ser o atual: a emissão que ainda estiver voando não solta
 * a trava da fatura nova nem escreve o erro dela na tela da fatura nova (o aviso de
 * erro da 14672 apareceu na janela da fatura seguinte).
 *
 * A garantia de verdade é a reserva no banco (reservar_emissao_asaas, na
 * asaas-cobranca), que cobre duas abas ou duas pessoas. Esta trava cuida da tela.
 */
export interface TravaEmissao {
    /** Pega a trava. Devolve o bilhete desta emissão, ou null se já há outra em andamento. */
    pegar(): symbol | null;
    /** Solta a trava, mas só se o bilhete ainda for o da emissão em andamento. */
    soltar(bilhete: symbol): void;
    /** O bilhete ainda é o da emissão desta janela? False depois que ela trocou de fatura. */
    ehAtual(bilhete: symbol): boolean;
    /** A janela trocou de fatura: esquece qualquer emissão anterior. */
    zerar(): void;
    emAndamento(): boolean;
}

export function criarTravaEmissao(): TravaEmissao {
    let atual: symbol | null = null;
    return {
        pegar() {
            if (atual) return null;
            atual = Symbol('emissao');
            return atual;
        },
        soltar(bilhete) {
            if (atual === bilhete) atual = null;
        },
        ehAtual(bilhete) {
            return atual === bilhete;
        },
        zerar() {
            atual = null;
        },
        emAndamento() {
            return atual !== null;
        },
    };
}
